export default "__VITE_ASSET__XM87c2f7__"